/* backup for assets/registry_info.js - which is not stored in git */
/* use this as the primary file and copy changes to assets/registry_info.js */
$(function() {

	var $container = $('body');
	var itemsOutOfStock = false;

	window.vent.on('giftsReceivedModalOpen', function() {
		$container = $('#gifts-received-modal');
		initialize();
	});

	/**
	 * Function to initializes Gift Card
	 */
	function initialize() {

		if($('#gift_reggie-registry_id').length) {

			var registryId = $('#gift_reggie-registry_id').val();
			var isRegistryEdit = false;

			if(String(window.location.href).indexOf('/registry/') >= -1) {
				var href = String(window.location.href);
				var startPos = href.indexOf('/registry/') + 10;
				var endPos = href.indexOf('/', startPos) || -1;

				// if no trailing slash, check for trailing variable
				if(endPos === -1) {
					endPos = href.indexOf('?', startPos) || -1;
				}

				// or trailing hash
				if(endPos === -1) {
					endPos = href.indexOf('#', startPos) || -1;
				}

				registryId = href.substring(startPos, endPos);
				isRegistryEdit = true;
			}

			var registryForm = {};
			registryForm['registry_id'] = registryId;
			//

			$container.find('.gift_reggie-redeem_btn').off('click');
			$container.find('.gift_reggie-invalid-redeem_btn').off('click');
			// $container.find('.gift_reggie-redeem_btn').on('click', function() {
			// 	var customerId;
			// 	if($('#gift_reggie-registry_card_id').length){
			// 		//$(document).trigger('gift_reggie:redeem');
			// 	}
			// });
			$container.find('.gift_reggie-redeem_btn').on('click', function() {
				var customerId;
				if($('#gift_reggie-registry_card_id').length) {

					var $modalTriggerButton = $('#modal-triggers').find('[href="#registry-redemption-modal"]');
					var $modalCloseButton = $('#registry-redemption-modal').find('.modal__close');

					$modalTriggerButton[0].dispatchEvent(new window.CustomEvent('click', {
						currentTarget: $modalTriggerButton[0],
						target: $modalTriggerButton[0],
						bubbles: true,
						cancelable: true
					}));

					var newCartData = [];
					var $productCards = $('.registry-items-bucket__registry-items .horizontal-product-card');

					$productCards.each(function(index, value) {
						var $card = $(value);
						if ($card.attr('data-instock') === "true"){
							// console.log('this item is in stock', parseInt($card.attr('data-variant-id')));
							item_properties = {};
							item_properties._registry_id = registryId;
							item_properties._redeem_gift_card = "true";
							item_properties._registry_type = "virtual";
							item_properties._gift_registry = true;

							if($card.attr('data-bundle_info')) {
								item_properties._bundle_ids = $card.attr('data-bundle_info');
								item_properties.bundle_ids = $card.attr('data-bundle_info');
							}
							if($card.attr('data-checkout_info')) {
								if($card.attr('data-checkout_info') != '[]'){
									item_properties.checkout = $card.attr('data-checkout_info');
								}
							}
							var quantity = parseInt($card.attr('data-quantity-has'));
							if(quantity <= 0){
								quantity = 1
							}

							newCartData.push({
								id: parseInt($card.attr('data-variant-id')),
								quantity: quantity,
								properties: item_properties
							});
						} else {
				//			console.log('this item is not in stock', parseInt($card.attr('data-variant-id')));
							itemsOutOfStock = true;
						}
					});

					customerId = $('#gift_reggie-registry_card_id').val();
					window.registryGiftCardDiscount = customerId;

					var $registryBucketsContainer = $('.registry-items-bucket');
					$registryBucketsContainer.addClass('is-processing');

					var cartModule = $('[data-cart]')[0].module;
					cartModule.addItems(newCartData, false).then(function(success) {
						if(success) {
							// add to cart success
							notifyCart(customerId);
							updateRedeemCart();

							setTimeout(() => {
								$modalCloseButton[0].dispatchEvent(new window.CustomEvent('click', {
									currentTarget: $modalCloseButton[0],
									target: $modalCloseButton[0],
									bubbles: true,
									cancelable: true
								}));
								$('[data-show-cart]').click()
							}, 3000);
						}
						else {
							// add to cart failed
							$registryBucketsContainer.removeClass('is-processing');
						}
					}, function() {
						// add to cart error
						$registryBucketsContainer.removeClass('is-processing');
					});
				}
			});

			$(document).on('gift_reggie:redeem', function(){
				// console.log('gift_reggie:redeem');
				// console.log('DIFF REDEEM');
				customerId = $('#gift_reggie-registry_card_id').val();
				redeemGiftCardDiscount(customerId);
			})

			// If there is no amount returned (endpoint errors because no credit tied to registry)
			$container.find('.gift_reggie-invalid-redeem_btn').on('click', function() {
				//redeemNoDiscount();
				var customerId;
				if($('#gift_reggie-registry_card_id').length) {

					var $modalTriggerButton = $('#modal-triggers').find('[href="#registry-redemption-modal"]');
					var $modalCloseButton = $('#registry-redemption-modal').find('.modal__close');

					$modalTriggerButton[0].dispatchEvent(new window.CustomEvent('click', {
						currentTarget: $modalTriggerButton[0],
						target: $modalTriggerButton[0],
						bubbles: true,
						cancelable: true
					}));

					var newCartData = [];
					var $productCards = $('.registry-items-bucket__registry-items .horizontal-product-card');

					$productCards.each(function(index, value) {
						var $card = $(value);
						if ($card.attr('data-instock') === "true"){
							item_properties = {};
							item_properties._registry_id = registryId;
							item_properties._redeem_gift_card = "true";
							item_properties._registry_type = "virtual";
							item_properties._gift_registry = true;

							if($card.attr('data-bundle_info')) {
								item_properties._bundle_ids = $card.attr('data-bundle_info');
								item_properties.bundle_ids = $card.attr('data-bundle_info');
							}
							if($card.attr('data-checkout_info')) {
								item_properties.checkout = $card.attr('data-checkout_info');
							}

							var quantity = parseInt($card.attr('data-quantity-has'));
							if(quantity <= 0){
								quantity = 1
							}

							newCartData.push({
								id: parseInt($card.attr('data-variant-id')),
								quantity: quantity,
								properties: item_properties
							});
						} else {
							// console.log('this item is not in stock', parseInt($card.attr('data-variant-id')));

							itemsOutOfStock = true;
						}
					});

					customerId = $('#gift_reggie-registry_card_id').val();

					var $registryBucketsContainer = $('.registry-items-bucket');
					$registryBucketsContainer.addClass('is-processing');

					var cartModule = $('[data-cart]')[0].module;
					// console.log('newcartdata is',newCartData)
					cartModule.addItems(newCartData, false).then(function(success) {
						if(success) {
							// add to cart success

							// add to cart success
							notifyCart(customerId);
							updateRedeemCart();

							setTimeout(() => {
								$modalCloseButton[0].dispatchEvent(new window.CustomEvent('click', {
									currentTarget: $modalCloseButton[0],
									target: $modalCloseButton[0],
									bubbles: true,
									cancelable: true
								}));
								$('[data-show-cart]').click()
							}, 3000);
						}
						else {
							// add to cart failed
							$registryBucketsContainer.removeClass('is-processing');
						}
					}, function() {
						// add to cart error
						$registryBucketsContainer.removeClass('is-processing');
					});
				}
			});

			/**
			 * On Variant Change adjust the items for the cart attributes
			 */
			$(document).on('change', '[data-gift-reggie-variant-id]:checked', function () {
				$container.find('.gift-reggie__variant-id').val($(this).attr('data-gift-reggie-variant-id'));
				$container.find('.gift-reggie__variant-price').val($(this).attr('data-gift-reggie-price'));
				$container.find('.gift-reggie__variant-sale-price').val($(this).attr('data-gift-reggie-sale'));
				$container.find('.gift-reggie__variant-title').val($(this).attr('data-label'));
				$container.find('.gift-reggie__variant-image').val($(this).attr('data-gift-reggie-variant-image'));
			});

			retrieveGiftCardCode(registryForm);

		}
	}

	// Utility Functions
	/**
	 * Function to console log items
	 */
	function ConsoleLogger (str) {
		if(( typeof window.console !== 'undefined' && typeof window.console.log !== 'undefined')) {
			// console.log(str);
		}
	}

	//Setters
	/**
	 * Function used to store the gift card code value in a hidden input
	 *
	 * @param {string} giftCardCode : gift card code contained in the JSON response
	 * @param {Jquery Object} $objGiftCardID : input type hidden to store value
	 */
	function setGiftCardDiscount (giftCardCode, $objGiftCartID) {
		$objGiftCartID.val(giftCardCode);
	}

	//Gift Card Functions
	/**
	 * Function to retrieve Registry ID, Gift Card Code, and Gift Card Amount
	 * from endpoint.
	 *
	 * @param formData : Gift Reggie ID JSON Format {"registry_id": “123”};
	 */
	function retrieveGiftCardCode(formData) {
		console.warn('check_balance', formData);
		$.ajax({
			url: '/apps/vr-api/v1/check_balance',
			type: 'post',
			data: formData,
			success: function(response) {
				ConsoleLogger("Check Balance: Success");
				var giftCardCode = response.gift_card_code;
				var giftCardAmount = response.amount;

				console.log('giftCardAmount', giftCardAmount);
				if(giftCardAmount > 0){
					setGiftCardDiscount(giftCardCode, $('#gift_reggie-registry_card_id'));
					displayGiftCardAmount(giftCardAmount, $container.find('.gift_reggie-amount'));
					$container.find('.gift_reggie-gift_card_valid').addClass('show');
					$container.find('.gift_reggie-gift_card_invalid').removeClass('show');
				} else {
					//amount is 0
					$container.find('.gift_reggie-gift_card_invalid').addClass('show');
					$container.find('.gift_reggie-gift_card_valid').removeClass('show');
				}
			},
			error: function(response) {
				ConsoleLogger("Check Balance: Failure!");
				if(response.responseText) {
					var responseText = JSON.parse(response.responseText);
					if(responseText.message == "Registry not found") {
						$container.find('.gift_reggie-gift_card_invalid').addClass('show');
						$container.find('.gift_reggie-gift_card_valid').removeClass('show');
						ConsoleLogger("No Credit Associated with Registry Account");
					}
				}
			}
		});
	}

	$.get('/cart.json', function(data){
		if(data.attributes.registry_id){
			retrieveAmount({'registry_id': data.attributes.registry_id});
		}
	});
	function retrieveAmount(formData){
		$.ajax({
			url: '/apps/vr-api/v1/check_balance',
			type: 'post',
			data: formData,
			success: function(response) {
				var amount = response.amount;
				if($('.gift_reggie-amount').length){
					if(amount > 0){
						displayGiftCardAmount(amount, $('.gift_reggie-amount'));
						$container.find('.gift_reggie-gift_card_valid').addClass('show');
						$container.find('.gift_reggie-gift_card_invalid').removeClass('show');
					} else {
						$container.find('.gift_reggie-gift_card_invalid').addClass('show');
						$container.find('.gift_reggie-gift_card_valid').removeClass('show');
					}
				}
			}
		});
	}

	function updateRedeemCart() {
		$.get('/cart.json', function(data){
			if(data.attributes.registry_id){
				let check_data = {'registry_id': data.attributes.registry_id};
				$.ajax({
					url: '/apps/vr-api/v1/check_balance',
					type: 'post',
					data: check_data,
					success: function(response) {
						var amount = response.amount;
						//fast fix
						$('.cart-overlay .cart-redemption').empty().append('<ul style="margin: 0;"><li class="cart-total" role="presentation"><span class="label">Redemption Credit</span><div><span class="gift_reggie-amount">$'+amount.toFixed(2)+'</span></div></li></ul>');
					}
				});
			}
		});
	}

	/**
	 * Function that adds the gift card code to the cart attribute in order to
	 * redeem on next purchase
	 *
	 * @param {string} gift_card_code : Gift Card Code returned from JSON Response
	 */
	function redeemGiftCardDiscount (gift_card_code) {
		var attribute_hash = {}
		if(gift_card_code != "") {
			attribute_hash['attributes[_gift_card_code]'] = gift_card_code;
		}
		if (itemsOutOfStock){
			attribute_hash['attributes[items_out_of_stock]'] = true
		}
		console.warn('redeemGiftCardDiscount', attribute_hash, gift_card_code);
		$.ajax({
			type: 'POST',
			url: '/cart/update.js',
			data: attribute_hash,
			dataType: 'json',
			success: function(response) {
				console.warn("SUCCESS - Redeem Process: Activated");
				notifyCart(gift_card_code);
			},
			error: function(e,f,g) {
				console.warn('ERROR -', e,f,g);
			}
		}).then(function() {
			//$("body").trigger('redeem_giftreggie')
			updateRedeemCart();
		});
	}

	function notifyCart(gift_card_code) {
		let $cart_notification = $('.cart-notification .cart-notification__cta a[href="/checkout"]')
		if($cart_notification.length) {
			let link = $cart_notification.attr('href');
			link +=  '/?discount='+gift_card_code;
			$cart_notification.attr('href', link)
		}
	}

	// redeems registry with no gift card if endpoint doesn't have credit attached
	function redeemNoDiscount () {
		if($('.gift-reggie-redeem-form')) {
			$('.gift-reggie-redeem-form').submit();
		}
	}

	function removeGiftCardDiscount() {
		$.ajax({
			type: 'POST',
			url: '/cart/update.js',
			data: 'attributes[_gift_card_code]=',
			dataType: 'json',
			success: function (response) {
				ConsoleLogger("Redeem Process: Cancelled");
				let $cart_notification = $('.cart-notification .cart-notification__cta a')
				if($cart_notification.length) {
					$cart_notification.attr('href', '/checkout');
				}
				//hide show redeem btn, hide cancel button?
			}
		});
	}

	/**
	 * Function to used display the gift card amount in the DOM object
	 * @param {Int} giftCardAmount : Integer value in cents contained in the JSON response
	 * @param {Jquery Object} $objGiftCardAmount: DOM Element used to display the amount
	 */
	function displayGiftCardAmount(giftCardAmount, $objGiftCardAmount) {
		if($objGiftCardAmount.length) {
			var dollarValue = (Math.round(giftCardAmount * 10 * 10) / 100).toFixed(2);
			var amount = '$' + dollarValue.replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();

			//Encase multiple occurences of object
			$objGiftCardAmount.each(function() {
				$(this).text(amount);
			});
		}
	}

	initialize();
});